module.exports = __webpack_public_path__ + "assets/defaultWhite-4a8803.svg";